module.exports = __webpack_public_path__ + "static/media/surgeryQuestion.6fc8b380.mp3";